import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import ARFiber from '@/components/client/ARFiber/ARFiber';
import ProductDetail from "@pages/client/ProductDetail/ProductDetail";
import Categories from "@pages/client/Catalog/Catalog";

const AppRouter = () => {
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/home" element={<Categories />} />
                <Route path="/ruta2" element={<ARFiber />} />
                <Route path="/detail" element={<ProductDetail />} />
                <Route path="/" element={<Navigate to="/home" replace />} />
                <Route path="*" element={<div>404 - No encontrado</div>} />
            </Routes>
        </BrowserRouter>
    );
};

export default AppRouter;